import axios from "axios";

const HttpMethods = {
    GET: 'GET',
    POST: 'POST',
    DELETE: 'DELETE',
};

const _axios = axios.create();
const baseUrl: string | undefined = process.env.BASE_API_URL ? process.env.BASE_API_URL : "";
const restVersionPath: string | undefined = "";

const keyclock_auth_url: string | undefined = process.env.KEYCLOCK_AUTH_URL ? process.env.KEYCLOCK_AUTH_URL : "";
const client_id: string | undefined = process.env.CLIENT_ID ? process.env.CLIENT_ID : "";
const client_secret: string | undefined = process.env.CLIENT_SECRET ? process.env.CLIENT_SECRET : "";
const getToken = () => {
    //cwm-api-client
    //t6N7q8pClRwPJb90jG2eBFl4fHZzsdHK
    return axios.post(`${keyclock_auth_url}/realms/ndb-cwm/protocol/openid-connect/token`, {
            client_id: client_id,
            client_secret: client_secret,
            grant_type: "client_credentials",
            scope: "roles"
        },
        {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        })
}

async function configure() {
    let value: any = await getToken();
    _axios.defaults.headers.common["Authorization"] = `Bearer ${value.data.access_token}`;
}

const get = async (path = "") => {
    await configure();
    let url = baseUrl + restVersionPath + path;
    return _axios.get(url);
}


const put = async (path = "", payload: any) => {
    await configure();
    let url = baseUrl + restVersionPath + path;
    return _axios.put(url, payload);
}

const post = async (path = "", payload: any) => {
    await configure();
    let url = baseUrl + restVersionPath + path;
    return _axios.post(url, payload, {
        headers: {
            'content-type': 'application/json'
        }
    });
}


const deleteOne = async (path = "") => {
    configure();
    let url = baseUrl + restVersionPath + path;
    return _axios.delete(url);
}

const logoutAllUserRelatedSessions = async (userId: string) => {

    await configure();
    return _axios.post(`${keyclock_auth_url}/admin/realms/${client_id}/users/${userId}/logout`, null);
}


const getAxiosClient = () => _axios;

const ClientHttpService = {
    HttpMethods,
    configure,
    getAxiosClient,
    get,
    put,
    post,
    deleteOne,
    logoutAllUserRelatedSessions
};


export default ClientHttpService;
